/// <reference path="./typings/types.d.ts" />

import * as React from 'react';
import { RegExpEscape, kanaConverter,toENEn } from './functions';
import { Input } from './input';
import { DataList } from './datalist';

/**
 * クラス
 */
export class AutoSuggest extends React.Component<AutoSuggestProps, AutoSuggestStateProps> {

	private originItems : Items[] = []
	private selectValue : string = ''
	private textInput   : HTMLInputElement

	// 初期設定
	public static defaultProps : AutoSuggestProps = {
		items        : [],
		max          : 0,
		datalistId   : 'candidate-list',
		autoFocus    : false,
		displayFocus : false,
		inputPreview : false,
		match        : 'text'
	}

	constructor(props : AutoSuggestProps) {
		super(props);

		this.originItems = this.changeItemFormat();

		this.state = {
			value      : '',
			items      : [],
			selectItem : -1,
			over       : false
		};
	}

	componentWillUpdate() {
		this.originItems = this.changeItemFormat();
	}

	componentDidMount() {
		if (this.props.value) this.setValue(this.props.value);
		this.setInputValueState(this.textInput.value);
	}

	// アイテムの形式を再形成
	changeItemFormat() {
		const originItems = this.props.items;
		let items = [];

		for (let value of originItems) {
			if (!value.hasOwnProperty('key')) {
				items.push({ key : value, text : value });
			} else {
				items.push(value);
			}
		}

		return items as Items[];
	}

	// 元の入力値を取得
	getInputValueState() {
		return this.state.value;
	}

	// 入力欄の値をステータスに代入
	setInputValueState(value : string) {
		this.setState({ value : value });
	}

	// 選択した値を入力欄に代入
	setValue(value : string) {
		this.textInput.value = value;
	}

	// 入力欄を空にする（外部からの操作用）
	clearValue = () => {
		this.textInput.value = '';
	}

	// 選択した値を取得
	getSelectValue() {
		return this.selectValue;
	}

	// 選択した値を候補としてステータスにセット
	// （確定するまでの一時的な保存場所）
	setSelectValue(value : string) {
		this.selectValue = value;
	}

	// 選択した値のステータスをクリア
	clearSelectValue() {
		this.selectValue = '';
	}

	// データリストを閉じる
	switchClose() {
		if (!this.state.over) this.setState({ items : [] });
	}



	// データを絞り込む
	refine(searchText : string) {
		let items = this.originItems;

		let newItems : Items[] = [];

		if (searchText) {

			searchText = toENEn(searchText);
			searchText = kanaConverter.convertKanaToTwoByte(searchText);

			searchText = RegExpEscape(searchText);

			const regExpText = new RegExp(searchText, 'i');
			const key = this.props.match

			newItems = items.filter((Items) => {

				let data = Items;

				data[key] = toENEn(data[key]);
				data[key]= kanaConverter.convertKanaToTwoByte(data[key]);
				if (key === 'text' || key === 'key') {
					return regExpText.test(data[key]);
				} else {
					return regExpText.test(data['text']) || regExpText.test(data['key']);
				}
			});
		}

		this.setState({ items : newItems });
	}

	// アイテム数を取得
	getItemCount() {
		let total = this.state.items.length;
		if (this.props.max > 0 && total > this.props.max) total = this.props.max;
		return total;
	}

	// 選択アイテムの取得
	getSelectedItem() {
		return this.state.selectItem;
	}

	// 選択アイテムの切り替え
	changeSelectItem(itemNumber : number) {
		this.setState({ selectItem : itemNumber });
	}

	// データリストのホバーステータスの切り替え
	changeOverState(flag : boolean) {
		this.setState({ over : flag });
	}

	// 選択アイテムの切り替え
	resetState() {
		this.selectValue = '';
		this.setState({ items : [], over : false, selectItem : -1 });
	}

	// 入力要素をフォーカスする（外部からの操作用）
	inputFocus = () => {
		this.textInput.focus();
	}

	// 入力要素のchangeイベント発火
	inputChange() {
		this.props.onChange(this.textInput.value);
	}

	// レンダリング
	render() {
		return (
			<div className='auto-suggest'>
				<Input
					ref          = { el => { if (el) this.textInput = el.getInput(); } }
					autoFocus    = { this.props.autoFocus }
					displayFocus = { this.props.displayFocus }
					placeholder  = { this.props.placeholder }
					name         = { this.props.name }
					id           = { this.props.inputId }
					dataListId   = { this.props.datalistId }
					onKeyDown    = { this.props.onKeyDown }
					onKeyUp      = { this.props.onKeyUp }
					onKeyPress   = { this.props.onKeyPress }
					onChange     = { this.props.onChange }
					parent       = {({
						refine             : (value) => this.refine(value),
						inputPreview       : this.props.inputPreview,
						dataListClose      : () => this.switchClose(),
						getItemCount       : () => this.getItemCount(),
						getInputValueState : () => this.getInputValueState(),
						getSelectedItem    : () => this.getSelectedItem(),
						changeSelectItem   : (num) => this.changeSelectItem(num),
						setSelectValue     : (value) => this.setSelectValue(value),
						clearSelectValue   : () => this.clearSelectValue(),
						setInputValue      : (value) => this.setInputValueState(value),
						setValue           : (value) => this.setValue(value),
						getSelectValue     : () => this.getSelectValue(),
						resetState         : () => this.resetState()
					})}
					/>
					<DataList
						items           = { this.state.items }
						max             = { this.props.max }
						id              = { this.props.datalistId }
						selectItem      = { this.getSelectedItem() }
						inputValue      = { this.state.value }
						dataListClose   = { () => this.switchClose() }
						changeOverState = { (flag) => this.changeOverState(flag) }
						setInputValue   = { (value) => this.setInputValueState(value) }
						setValue        = { (value) => this.setValue(value) }
						setSelectValue  = { (value) => this.setSelectValue(value) }
						resetState      = { () => this.resetState() }
						inputFocus      = { () => this.inputFocus() }
						inputChange     = { () => this.inputChange() }
						/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/auto-suggest/src/auto-suggest.tsx